import { type QueryClient, queryOptions } from '@tanstack/react-query';

import { mfaClient } from './client';

export const MFA_QUERY_KEYS = { credentials: 'mfa-credentials' } as const;

export const getMfaCredentialsQuery = () =>
  queryOptions({
    queryKey: [MFA_QUERY_KEYS.credentials],
    queryFn: mfaClient.getCredentials,
  });

export const invalidateMfaCredentials = (queryClient: QueryClient) =>
  queryClient.invalidateQueries({ queryKey: [MFA_QUERY_KEYS.credentials] });
